//API接口地址
export function apiBase() {
    let hostname = window.location.hostname,
        API_BASE_URL = 'https://market.chnrising.cn/'; //默认环境
    // 	if(hostname === 'crm.dunizb.cn') { //正式环境
    // 		API_BASE_URL = '';
    // 	} else if(hostname === 'http://wealth.chnrising.cn/') { //公网测试环境
    // 		API_BASE_URL = 'http://wealth.chnrising.cn/';
    // 	} else if(hostname === 'localhost') { //内网测试环境
    // 		API_BASE_URL = 'http://192.168.1.127:8001/';
    // 	}
    return API_BASE_URL;
}

//公共API
export function COMMON_API() {
    return {
        "verificationCode": apiBase() + "api/verificationCode",
        "register": apiBase() + "api/register",
        "login": apiBase() + "api/login",
        "account": apiBase() + "api/account",
        "setAccount": apiBase() + "api/setAccount",
        "service": apiBase() + "api/service",
        "order": apiBase() + "api/order",
        "adviser": apiBase() + "api/adviser",
        "bookingAdviser": apiBase() + "api/bookingAdviser",
        "addOrder": apiBase() + "api/addOrder",
        "revokeOrder": apiBase() + "api/revokeOrder",
        "newsList": apiBase() + "api/newsList",
        "newsDetail": apiBase() + "api/newsDetail",
        "activityList": apiBase() + "api/activityList",
        "activityDetail": apiBase() + "api/activityDetail",
        "lifeList": apiBase() + "api/lifeList",
        "lifeDetail": apiBase() + "api/lifeDetail",
        "choiceList": apiBase() + "api/choiceList",
        "choiceDetail": apiBase() + "api/choiceDetail",
        "subjectDetail": apiBase() + "api/subjectDetail"
    }
}


// WEBPACK FOOTER //
// ./src/common/api.config.js